export default __webpack_public_path__ + "navigation-examples-embedded-navigation-1200-693186920c39ef37b053996e235d6301.webp";